module.exports = __webpack_public_path__ + "static/media/ibanezlogo.95735da6.png";